import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const CURRENCIES = [
  { code: "USD", symbol: "$", label: "US Dollar" },
  { code: "EUR", symbol: "€", label: "Euro" },
  { code: "MXN", symbol: "$", label: "Peso Mexicano" },
  { code: "ARS", symbol: "$", label: "Peso Argentino" },
  { code: "COP", symbol: "$", label: "Peso Colombiano" },
  { code: "GBP", symbol: "£", label: "Libra Esterlina" },
  { code: "BRL", symbol: "R$", label: "Real Brasileño" },
];

export const INVESTMENT_TYPES = [
  { value: "stock", label: "Acciones" },
  { value: "crypto", label: "Criptomonedas" },
  { value: "fund", label: "Fondos / ETFs" },
  { value: "real_estate", label: "Bienes Raíces" },
  { value: "deposit", label: "Depósitos" },
  { value: "other", label: "Otro" },
];

export const formatCurrency = (amount, currency = "USD") => {
  const num = Number(amount) || 0;
  const sym = CURRENCIES.find((c) => c.code === currency)?.symbol || "$";
  return `${sym}${num.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const formatCompact = (amount, currency = "USD") => {
  const num = Number(amount) || 0;
  const sym = CURRENCIES.find((c) => c.code === currency)?.symbol || "$";
  return `${sym}${num.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
};
